// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__0ax1n","opacity-transition":"error_opacity-transition__Qlt4E"};